<template>
  <div class="products">
    <div class="content-wrapper">
      <div class="title">
        <span>商品管理</span>
        <Button v-if="userInfo.can_add_stock_product" @click="onAddProduct">新增商品</Button>
      </div>
      <div class="tool-wrapper">
        <div class="menu-box">
          <div
            v-for="(item, index) in status_list"
            :key="`st${index}`"
            class="menu-item"
            :class="[form_data.status == item.value ? 'active' : '']"
            @click="form_data.status = item.value"
          >
            {{ item.name }}({{ item.count }})
          </div>
        </div>
        <div class="search-box">
          <input
            v-model="form_data.keyword"
            type="text"
            placeholder="输入关键词进行搜索商品"
            @keyup.enter="onSearch"
          />
          <div class="search-btn" @click="onSearch">搜索</div>
        </div>
      </div>
      <div class="table-box">
        <table>
          <thead>
            <tr>
              <th class="col-check"></th>
              <th>商品信息</th>
              <th>上架时间</th>
              <th>驳回原因</th>
              <th>操作</th>
            </tr>
          </thead>
            <tbody v-for="(item,index) in product_list" :key="index">
                <tr>
                  <td>
                    <div class="col-check">
                      <Checkbox :value="checked_list.includes(item.uuid)" :label="item.uuid" @on-change="(val)=>handleSingleCheck(val,item.uuid)"></Checkbox>
                    </div>
                  </td>
                  <td>
                    <div class="col-info">
                      <div class="product-image">
                        <img :src="item.image" alt="" />
                        <div v-if="item.sale_mode == 1" class="presale-tag">预售</div>
                      </div>
                      <div class="text-info">
                        <div class="product-name">{{ item.name }}</div> 
                        <div class="category">
                          款式分类:{{ item.product_category_name }}
                        </div>
                        <div class="desc">款号:{{ item.param.find(item=>{return item.key === '款号'}).value || '-' }}</div>
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="col-time">{{ item.create_time }}</div>
                  </td>
                  <td>
                    <div class="col-time">
                      <Poptip placement="top" trigger="hover" :disabled="!item.reason">
                        <template #content>
                          {{ item.reason }}
                        </template>
                        <div>{{ item.reason ? '驳回原因' : '-' }}</div>
                      </Poptip>
                    </div>
                  </td>
                  <td>
                    <div class="col-action">
                      <template
                        v-if="['unsale', 'onsale'].includes(form_data.status)"
                      >
                        <div class="unsale-btn" @click="switchSaleStatus(item.uuid)">
                          {{ form_data.status == 'onsale' ? "下架" : "上架" }}
                        </div>
                        <div class="divider">|</div>
                      </template>
                      <div class="edit-btn" @click="edit(item.uuid)">编辑</div>
                      <template
                        v-if="['unsale', 'draft'].includes(form_data.status)"
                      >
                        <div class="divider">|</div>
                        <div class="delete-btn" @click="onDelete(item.uuid)">
                          {{ form_data.status === 0 ? "永久删除" : "删除" }}
                        </div>
                      </template>
                     
                       <template
                        v-if="['onsale'].includes(form_data.status) && settings.open_commission  && settings.common_commission_min_rate"
                      >
                        <div class="divider">|</div>
                        <div class="edit-btn" @click="openCommission(item)">推广计划</div>
                      </template>
                      <div class="divider">|</div>
                      <div class="edit-btn" @click="onRestock(item)">补货</div>
                    </div>
                  </td>
                </tr> 
            </tbody>
        </table>
      </div>
      <div class="bottom-tool">
        <div class="batch-tool">
          <Checkbox
            :indeterminate="indeterminate"
            :value="checkAll"
            @click.prevent.native="handleCheckAll"
            >全选</Checkbox
          >
          <div
            v-if="form_data.status != 'draft'"
            class="batch-unsale"
            @click="batchSwitchStatus(form_data.status)"
          >
            {{ form_data.status == 'onsale' ? "批量下架" : "批量上架" }}
          </div>
          <div class="batch-delete" @click="onDelete(checked_list, true)">
            批量删除
          </div>
        </div>
        <div class="page-container">
          <Page
            :total="total_count"
            size="small"
            prev-text="上一页"
            next-text="下一页"
            @on-change="onPageChange"
          ></Page>
        </div>
      </div>
    </div>
    <popup :show.sync="is_popup_show" width="350px"  @on-close="is_popup_show = false">
			<div
      style="padding: 25px"
      class="flex flex-direction justify-center align-center commission-box"
      > 
      <h1 class="text-left">推广计划</h1>
      <div
        class="text-666 margin-top-10 text-14 text-center line-height: 22px"
      >
        推广佣金比不能低于{{ settings.common_commission_min_rate}}%
      </div>
      <div class="margin-top-20 flex align-center " style="width:100%">
        <div>开启推广：</div>
        <RadioGroup v-model="tmpItem.is_join_commission">
            <Radio :label="1" >开</Radio>
            <Radio :label="0">关</Radio>
        </RadioGroup>
      </div>
      <div class="margin-top-20 flex align-center " style="width:100%">
        <div>推广佣金：</div>
        <Input style="text-align:center;flex:1" v-model="tmpItem.product_commission" placeholder="设置推广佣金" />
      </div>
      <div class="flex align-center justify-center w100" style="margin-top: 40px">
       
       <button class="cancel-btn cu-btn" @click="is_popup_show = false">
          取消
        </button>
        <button
          class="confirm-btn cu-btn margin-left-10"
          @click="confirmCommission()"
        >
          确认
        </button>
      </div>
    </div>
			</popup>
  </div>
</template>
<script>
import {
  getSetting,
  ProductCount,
  ProductDelete,
  ProductList,
  ProductOnsale,
  ProductUnsale,
  SetCommission
} from "@/api/index";
import Popup from "@/components/Popup.vue";
import { mapState } from "vuex";
export default {
  name: "Products",
  components: {
    Popup,
  },
  data() {
    return {
        uid: "",
        product_list: [],
        indeterminate: false,
        checkAll: false,
        checked_list: [],
        status_list: {
            unauth: { name: "待审核", value: 'unauth', count: 0 },
            onsale: { name: "展示中", value: 'onsale', count: 0 },
            unsale: { name: "已下架", value: 'unsale', count: 0 },
            reject: { name: "已驳回", value: 'reject', count: 0 },
            draft: { name: "草稿箱", value: 'draft', count: 0 },
        },
        form_data: {
            page: 1,
            limit: 15,
            status: 'onsale',
            keyword: "",
        },
        is_popup_show:false,
        tmpItem:{},
        settings:{
          common_commission_min_rate: 0, //普通商品最低佣金比例
          open_commission: 0, //开启佣金
        }
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
    total_count() {
      const { status } = this.form_data;
      switch (status.toString()) {
        case "0":
          return this.unsale_count;
        case "1":
          return this.onsale_count;
        case "-1":
          return this.draft_count;
        default:
          return 0
      }
    },
  },
  watch: {
    "form_data.status"(news, olds) {
      if (news != olds) {
        console.log("status change");
        this.getProductList();
      }
    },
  },
  mounted() {
    this.uid = this.userInfo.code;
    this.getProductList();
    this.getSetting()
    this.$store.dispatch('getUser');
  },
  methods: {
    async getSetting(){
        const {code,msg,data} = await getSetting({code:"zone",key:'zone'});
        this.settings = data;
    },
    openCommission(item){
      this.tmpItem = item
      this.is_popup_show = true
    },
    async confirmCommission(){
       try {
            if(this.tmpItem.product_commission < this.settings.common_commission_min_rate){
              this.$layer.msg(`佣金比例不能低于${this.settings.common_commission_min_rate}%`)
              return;
            }
            const param = {
              uuid:this.tmpItem.uuid,
              product_commission:this.tmpItem.product_commission,
              is_join_commission: this.tmpItem.is_join_commission
            }
            const {code,msg} = await SetCommission(param);
            if(code == 0){
              this.$layer.msg('设置成功')
              this.getProductList()
              this.is_popup_show = false
            }else{
              this.$layer.msg(msg)
            }
            
          } catch (e) {
            console.log("e", e);
          }
    },
    getParamValue(params, key) {
      if (!params || !Array.isArray(params)) return '-';
      const target = params.find(p => p.key === key);
      return target ? target.value : '-';
    },
    onAddProduct(){
      this.$router.push({
        name: "ProductEdit",
        query:{uuid:'0'}
      })
    },
    onDelete(uuid, batch = false) {
      if(batch && (!uuid.length || !uuid)){
        this.$layer.msg('请选择要删除的商品');
        return;
      }
      this.$DModal.confirm({
        content: "确认删除？",
        onOK: async () => {
          try {
            const param = {};
            param.uuid = batch ? uuid.join(",") : uuid;
            await ProductDelete(param);
            this.checkAll = false;
            this.indeterminate = false;
            this.checked_list = [];
            this.$layer.msg(`操作成功`)
            this.getProductList()
          } catch (e) {
            console.log("e", e);
          }
        },
      });
    },
    batchSwitchStatus(status) {
      switch (status.toString()) {
        default:
          this.onsale(this.checked_list, true);
          break;
        case "onsale":
          this.unsale(this.checked_list, true);
          break;
      }
    },
    async onsale(uuid, batch = false) {
      try {
        const param = {};
        batch ? (param.is_batch = true) : null;
        param.uuid = batch ? uuid.join(",") : uuid;
        const { msg } = await ProductOnsale(param);
        this.$layer.msg(msg);
        this.getProductList();
        this.checkAll = false;
        this.indeterminate = false;
        this.checked_list = [];
      } catch (e) {
        console.log("e-msg-onsale", e);
      }
    },
    async unsale(uuid, batch = false) {
      try {
        const param = {};
        batch ? (param.is_batch = true) : null;
        param.uuid = batch ? uuid.join(",") : uuid;
        const { msg } = await ProductUnsale(param);
        this.$layer.msg(msg);
        this.getProductList();
        this.checkAll = false;
        this.indeterminate = false;
        this.checked_list = [];
      } catch (e) {
        console.log("e-msg-unsale", e);
      }
    },

    switchSaleStatus(uuid) {
      const { status } = this.form_data;
      switch (status) {
        case "onsale":
          console.log("change-to-unsale");
          this.unsale(uuid);
          break;
        case "unsale":
          console.log("change-to-onsale");
          this.onsale(uuid);
          break;
      }
    },
    edit(uuid) {
      this.$router.push({ name: "ProductEdit", query: { uuid } });
    },
    //>补货:商品来源于款式(design_id>0)则直接下大货,否则先去做款式设计
    onRestock(item) {
      const design_id = Number(item.design_id) || 0;
      if (design_id > 0) {
        if (!item.design_uuid) {
          this.$layer.msg("未找到关联款式,无法下大货");
          return;
        }
        this.$router.push({
          name: "WorkBenchSummary",
          query: { uuid: item.design_uuid, from: "design" },
        });
        return;
      }
      this.$router.push({ name: "WorkBenchDesign" });
    },
    onPageChange(e) {
      console.log("page_change", e);
      this.form_data.page = e;
      this.getProductList();
    },
    handleSingleCheck(checked, uuid) {
      if (checked) {
        if (!this.checked_list.includes(uuid)) {
          this.checked_list.push(uuid);
        }
      } else {
        const index = this.checked_list.indexOf(uuid);
        if (index > -1) {
          this.checked_list.splice(index, 1);
        }
      }
      //>触发全选/半选响应
      this.onCheckChange();
    },
    onCheckChange(data) {
      console.log("data", data);
      if (this.checked_list.length === 0) {
        this.indeterminate = false;
        this.checkAll = false;
      } else if (this.checked_list.length === this.product_list.length) {
        this.indeterminate = false;
        this.checkAll = true;
      } else {
        this.indeterminate = true;
        this.checkAll = false;
      }
    },
    handleCheckAll() {
      console.log("checkaaa");
      if (this.indeterminate) {
        this.checkAll = false;
      } else {
        this.checkAll = !this.checkAll;
      }
      this.indeterminate = false;
      if (this.checkAll) {
        this.checked_list = this.product_list.map((item) => item.uuid);
        console.log("this.checked_list", this.checked_list);
      } else {
        this.checked_list = [];
      }
    },
    onSearch() {
      console.log("产品管理搜索");
      this.getProductList();
    },
    async onGetCount(){
      try{
        const {data} = await ProductCount(this.form_data);
        for(let code in data) {
          console.log('code',code);
          if(code != 'all'){
            this.status_list[code].count = data[code]
          }
        }
        console.log("data",data);
      }catch(e){
        console.log('e-count',e);
      }
    },
    async getProductList() {
      this.onGetCount();
      return ProductList({
        ...this.form_data,
        code: this.uid,
        // status: this.status,
      }).then((response) => {
        const { data } = response;
        this.product_list = data;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.products {
  width: 100%;
  background: #ffffff;
  height: 100%;
  .content-wrapper {
    padding: 30px 30px 0 30px;
    .title {
      width: 100%;
      border-bottom: 1px solid #d6d6d6;
      // padding-bottom: 15px;
      display:flex;
      align-items:center;
      column-gap:30px;
      span {
        font-weight: bold;
        font-size: 18px;
        color: #000000;
        padding-bottom: 17px;
        border-bottom: 3px solid #ff5967;
      }

    }
    .tool-wrapper {
      margin-top: 28px;
      display: flex;
      justify-content: space-between;
      .menu-box {
        display: flex;
        align-items: center;
        .menu-item {
          // &:nth-child(2) {
          //   margin: 0 40px;
          // }
          margin:0 20px;
          &:first-child{
            margin-left:0;
          }
          cursor: pointer;
          font-size: 14px;
          color: #666666;
          &.active {
            color: #1a1a1a;
            font-weight: bold;
          }
        }
      }
      .search-box {
        background: #f2f3f5;
        border-radius: 20px;
        display: flex;
        align-items: center;
        padding: 10px 20px;
        width: 322px;
        input {
          border: none;
          outline: none;
          background: transparent;
          flex: 1;
          padding-right: 10px;
          // padding-left:20px;
        }
        .search-btn {
          // padding-right:20px;
          padding-left: 20px;
          border-left: 1px solid rgba(0, 0, 0, 0.1);
        }
      }
    }
    .table-box {
      margin-top: 20px;
      width:100%;
      overflow:hidden;
      table{
        width:100%;
        table-layout:fixed;
        border-collapse: separate;
        border-spacing: 0 10px;
        thead{
          background:#f0f0f0;
          height:40px;
          tr{
            th{
              text-align:center;
              &.col-check{
                width: 80px;
                padding: 12px;
              }
            }
          }
        }
        // ::v-deep .ivu-checkbox-group {
        //     width: 100%;
        //   }
        tbody{
          // display:table;
          width:100%;
          margin-bottom:10px;
          tr{
            width:100%;
            box-shadow: inset 0 0 0 1px #e6e6e6; 
            border-radius: 8px;
              td{
                vertical-align: middle;
                text-align:center;
                padding:10px 0;
                .col-check {
                  width: 80px;
                  padding: 12px;
                  ::v-deep .ivu-checkbox-group-item,
                    .ivu-checkbox-wrapper-checked {
                      border-spacing:0;
                      span {
                        &:nth-child(2) {
                          display: none;
                        }
                      }
                    }
                }

                .col-info {
                  flex: 1;
                  text-align: left;
                  display: flex;
                  .product-image {
                    width: 102px;
                    height: 102px;
                    margin-right: 20px;
                    border: 1px solid #e6e6e6;
                    border-radius: 5px;
                    object-fit:cover;
                    flex-shrink:0;
                    overflow:hidden;
                    position:relative;
                    img{
                      width:100%;
                      height:100%;
                      border-radius:5px;
                    }
                    .presale-tag{
                      position:absolute;
                      top:0;
                      left:0;
                      background:#ff5967;
                      color:#fff;
                      border-radius:8px 0 8px 0;
                      padding:3px 5px;
                    }
                  }
                  .text-info {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    width:100%;
                    .product-name {
                      font-size: 16px;
                      color: #333333;
                      font-weight: bold;
                      margin-bottom: 15px;
                      //>两行文本省略
                      display:-webkit-box;
                      -webkit-line-clamp:2;
                      line-clamp:2;
                      -webkit-box-orient:vertical;
                      overflow:hidden;
                      text-overflow:ellipsis;
                      word-break:break-all;
                    }
                    .desc,
                    .category {
                      font-size: 12px;
                      color: #808080;
                      white-space:nowrap;
                      text-overflow:ellipsis;
                      overflow:hidden;
                    }
                  }
                }
                .col-time {
                  flex: 0 0 300px;
                  text-align: center;
                }
                .col-action {
                  flex: 0 0 200px;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  font-size: 13px;
                  .divider {
                    margin: 0 10px;
                  }
                  div {
                    &:nth-child(1) {
                      margin-left: 20px;
                    }
                  }
                  .unsale-btn,
                  .edit-btn,
                  .delete-btn {
                    cursor: pointer;
                    color: #666666;
                  }
                }
            }
          }
        }
      }
      .flex-table {
        display: flex;
        flex-wrap: wrap;
        ::v-deep .ivu-checkbox-group {
          width: 100%;
        }
        .flex-header-row {
          display: flex;
          justify-content: space-between;
          align-items: center;
          flex: 1;
          background: #f0f0f0;
          height: 40px;
          color: #666666;
          font-size: 14px;
          .col-check {
            width: 80px;
            padding: 12px;
          }
          .col-info {
            flex:0 0 50%;
            min-width:200px;
            max-width:500px;
            flex-shrink:0;
            text-align: center;
          }
          .col-time {
            flex: 0 0 30%;
            text-align: center;
          }
          .col-action {
            flex: 0 0 20%;
            display: flex;
            justify-content: center;
            align-items: center;
          }
        }
        .flex-row {
          width: 100%;
          margin-top: 10px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          border: 1px solid #f0f0f0;
          border-radius: 5px;
          padding: 10px;
          .col-check {
            padding: 12px;
            width: 80px;
            ::v-deep .ivu-checkbox-group-item,
            .ivu-checkbox-wrapper-checked {
              span {
                &:nth-child(2) {
                  display: none;
                }
              }
            }
          }
          .col-info {
            flex: 1;
            text-align: left;
            display: flex;
            .product-image {
              width: 102px;
              height: 102px;
              margin-right: 20px;
              border: 1px solid #e6e6e6;
              border-radius: 5px;
              object-fit:cover;
            }
            .text-info {
              display: flex;
              flex-direction: column;
              justify-content: center;
              .product-name {
                font-size: 16px;
                color: #333333;
                font-weight: bold;
                margin-bottom: 15px;
              }
              .desc,
              .category {
                font-size: 12px;
                color: #808080;
              }
            }
          }
          .col-time {
            flex: 0 0 300px;
            text-align: center;
          }
          .col-action {
            flex: 0 0 200px;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 13px;
            .divider {
              margin: 0 10px;
            }
            div {
              &:nth-child(1) {
                margin-left: 20px;
              }
            }
            .unsale-btn,
            .edit-btn,
            .delete-btn {
              cursor: pointer;
              color: #666666;
            }
          }
        }
      }
    }
    .bottom-tool {
      padding-top: 40px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .batch-tool {
        margin-left: 21px;
        display: flex;
        align-items: center;
        pointer-events: auto;
        .batch-unsale,
        .batch-delete {
          border-radius: 3px;
          border: 1px solid #cccccc;
          color: #1a1a1a;
          font-size: 14px;
          cursor: pointer;
          padding: 0 15px;
          height: 35px;
          line-height: 35px;
          cursor: pointer;
          pointer-events: auto;
          user-select:none;
        }
        .batch-unsale {
          margin-left: 20px;
        }
        .batch-delete {
          margin-left: 10px;
        }
      }
      .page-container {
        height: 35px;
      }
    }
  }
}

.commission-box{
.cancel-btn{
    width: 130px;
    height: 44px;
    background: #FFFFFF;
    border-radius: 4px 4px 4px 4px;
    border: 1px solid #E3E3E3;
    font-weight: 400;
    font-size: 16px;
    color: #999999;
}
.confirm-btn{
    width: 130px;
    height: 44px;
    background: #FF5967;
    border-radius: 4px 4px 4px 4px;
    font-weight: 400;
    font-size: 16px;
    color: #FFFFFF;
}
 ::v-deep .ivu-input {
    text-align: center;
            
  }
}
</style>
